// extracted by mini-css-extract-plugin
module.exports = {"truncated":"Truncate_truncated__1C0xI","truncate-tooltip":"Truncate_truncate-tooltip__3rxyG"};